import {
    getCustomDateTime,
    getTodayTime,
    getTomorrowTime,
    isTodayDay,
    isTomorrowDay,
} from 'helpers/datetime'
import { FORT_BATTLES, SORTIES_WITH_LEVEL } from 'helpers/i18n'
import { toRoman } from 'helpers'
import { UNIT_TYPES } from 'constants'
import { COMING, NOT_HELD_WITH_NEXT } from './translations'
import { getClosestPrimetimeStart } from 'helpers/schedule'

// todo: refactor, merge with Schedule/components/NoBattlesMessage/helpers
export function getNextBattleMessage(playdays, playdayStart, playdayEnd, unitType, currentHour) {
    const closestPrimetimeStart = getClosestPrimetimeStart(
        playdays, playdayStart, playdayEnd, unitType, currentHour
    )

    if (!closestPrimetimeStart) return null
    if (isTodayDay(closestPrimetimeStart.local())) {
        return getTodayTime(closestPrimetimeStart)
    }
    if (isTomorrowDay(closestPrimetimeStart.local())) {
        return getTomorrowTime(closestPrimetimeStart)
    }
    return getCustomDateTime(closestPrimetimeStart)
}

export const getBattlesNotHeldMessage = (battleType, vehicleLevel) => {
    if (battleType === UNIT_TYPES.SORTIE) {
        return NOT_HELD_WITH_NEXT(SORTIES_WITH_LEVEL(toRoman(vehicleLevel)))
    }

    if (battleType === UNIT_TYPES.FORT_BATTLE) {
        return NOT_HELD_WITH_NEXT(FORT_BATTLES)
    }

    return COMING
}



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/BattleRoomsSchedule/components/BattlesNotHeldMessage/helpers.js